module.exports = __webpack_public_path__ + "static/featuredSm-a8b92124e1446687db5e155bfff7d37f.svg";